import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesCardGameCardClub: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.945 6.1h1.53v6.09h-1.53Zm-1.52 6.09h1.52v4.57h-1.52Zm-1.52 4.57h1.52v6.1h-1.52Zm-1.53 6.1h1.53v6.09h-1.53Z\"/><path fill=\"currentColor\" d=\"M22.855 6.1h6.09V4.57h-6.09V1.52h-1.53v28.96h3.05v-1.53h-1.52zM3.045 30.48h18.28V32H3.045Zm15.24-4.58h1.52v3.05h-1.52Zm-4.57-16.76h-3.05v3.05h-3.05v3.05h3.05v1.52h-1.53v1.53h6.1v-1.53h-1.52v-1.52h3.04v-3.05h-3.04zm-9.15-6.09h1.53V6.1h-1.53ZM3.045 0h18.28v1.52H3.045Zm-1.52 1.52h1.52v28.96h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesCardGameCardClub
